import { EventEmitter } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { UserPassword, UserDetails } from '../../../../../models/user';
import { EventTrackerService, UserActionType, Page, TargetType } from '../../../../services/event-tracker/event-tracker.service';
import { UserService } from '../../../../services/user.service';
import { ModalService } from '../../../../services/modal/modal.service';
import { TranslateService } from '@ngx-translate/core';
import { AchooPopupComponent } from '../../../../core/achoo-popup/achoo-popup.component';
import { WebUtils } from '../../../../utils/web.utils';
var ChangePwdComponent = /** @class */ (function () {
    function ChangePwdComponent(eventTracker, userService, modalService, translate) {
        this.eventTracker = eventTracker;
        this.userService = userService;
        this.modalService = modalService;
        this.translate = translate;
        this.afterUpdatePasswordCallback = new EventEmitter();
        this.userPasswordData = new UserPassword();
        this.isEmpty = false;
    }
    ChangePwdComponent.prototype.ngOnInit = function () {
        this.userPasswordForm = new FormGroup({
            'oldPassword': new FormControl(this.userPasswordData.oldPassword),
            'newPassword': new FormControl(''),
            'repeatNewPassword': new FormControl('')
        });
    };
    Object.defineProperty(ChangePwdComponent.prototype, "oldPassword", {
        get: function () {
            return this.userPasswordForm.get('oldPassword');
        },
        enumerable: true,
        configurable: true
    });
    ChangePwdComponent.prototype.onSubmit = function () {
        if (this.userPasswordData.oldPassword && this.userPasswordData.newPassWord && this.userPasswordData.repeatNewPassword) {
            this.isEmpty = false;
            this.updateUserPassword();
        }
        else {
            this.isEmpty = (!this.userPasswordData.oldPassword && this.userPasswordData.newPassWord && this.userPasswordData.repeatNewPassword) ||
                (this.userPasswordData.oldPassword && !this.userPasswordData.newPassWord && !this.userPasswordData.repeatNewPassword) ? true : false;
        }
    };
    ChangePwdComponent.prototype.updateUserPassword = function () {
        var _this = this;
        var oldPassword = this.userPasswordData.oldPassword;
        var newPassword = this.userPasswordData.newPassWord;
        this.userService.updatePassword(oldPassword, newPassword).subscribe(function (res) {
            _this.afterUpdatePasswordCallback.emit(true);
            if (!_this.isUserDetailsChanged) {
                _this.popupTitle = _this.translate.instant('notification.success');
                _this.msgString = _this.translate.instant('account_settings.notification_msg.update_user_password_success');
                _this.modalService.close(_this._changePwdNotificationPopupRef);
                _this._changePwdNotificationPopupRef = _this.modalService.openMultipleModal(_this.changePwdNotificationPopup, null);
            }
            _this.userPasswordData = new UserPassword();
            _this.sendUpdateUserEvent();
        }, function (error) {
            _this.afterUpdatePasswordCallback.emit(false);
            _this.popupTitle = _this.translate.instant('notification.error');
            if (error.error.data === 'wrong_password') {
                _this.msgString = _this.translate.instant('account_settings.notification_msg.wrong_password');
                WebUtils.reportErrorToSentry('User provided incorrect password on password update', error);
            }
            else if (error.error.data === 'invalid_password') {
                _this.msgString = _this.translate.instant('account_settings.notification_msg.invalid_password');
                WebUtils.reportErrorToSentry('User provided incorrect password on password update', error);
            }
            else {
                _this.msgString = _this.translate.instant('account_settings.notification_msg.update_failed');
                WebUtils.reportErrorToSentry('Password update failed on Settings page', error);
            }
            _this.modalService.close(_this._changePwdNotificationPopupRef);
            _this._changePwdNotificationPopupRef = _this.modalService.openMultipleModal(_this.changePwdNotificationPopup, null);
        });
    };
    ChangePwdComponent.prototype.sendUpdateUserEvent = function () {
        this.eventTracker.trackUserAction(UserActionType.ACTION, Page.PROFILE, {
            id: this.currentUserDetails.id,
            name: this.currentUserDetails.firstName + ' ' + this.currentUserDetails.lastName,
            type: TargetType.USER
        }, {
            action: UserActionType.UPDATE,
        }, undefined, null, null);
    };
    Object.defineProperty(ChangePwdComponent.prototype, "isValidNewPwd", {
        get: function () {
            return (this.userPasswordData.repeatNewPassword && this.userPasswordData.newPassWord && (this.userPasswordData.repeatNewPassword === this.userPasswordData.newPassWord))
                || (this.userPasswordData.repeatNewPassword === '' && this.userPasswordData.newPassWord === '');
        },
        enumerable: true,
        configurable: true
    });
    ChangePwdComponent.prototype.hasFormChanged = function () {
        return this.userPasswordForm.dirty || (this.userPasswordForm.value.oldPassword !== ''
            && this.userPasswordForm.value.newPassword !== ''
            && this.userPasswordForm.value.repeatNewPassword !== '');
    };
    ChangePwdComponent.prototype.hasFormEmpty = function () {
        return !this.userPasswordForm.dirty || (this.userPasswordForm.value.oldPassword === '' && this.userPasswordForm.value.newPassword === ''
            && this.userPasswordForm.value.repeatNewPassword === '');
    };
    return ChangePwdComponent;
}());
export { ChangePwdComponent };



// WEBPACK FOOTER //
// ./src/app/main/account-setting/user-settings/change-pwd/change-pwd.component.ts.pre-build-optimizer.js